﻿import React from "react";

import  BuscarComercio  from '../../pages/Home/Components/BuscarComercio';

const CambiarComercio =()=> {
    return (
            <BuscarComercio/>
        );
    }
export default  CambiarComercio 
